module.exports = __webpack_public_path__ + "img/align_center.dcc6e896.svg";